import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IChatController } from 'ng-chat';
import { NGXLogger } from 'ngx-logger';
import { Chat, ChatMessage, ChatService, MessageService, NotificatioContext, Notification, SharedDataService } from 'orv-ui-base-lib';
import { Subscription } from 'rxjs/Subscription';

import { OrvChatAdapter } from './orv-chat-adapter';

@Component({
	selector: 'app-chat',
	templateUrl: './chat.component.html',
	styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnDestroy {
	messageSubcription: Subscription;

	loggedUserDepos: any[];

	constructor(private logger: NGXLogger, public adapter: OrvChatAdapter,
		private sharedDataService: SharedDataService,
		private chatService: ChatService,
		private translateService: TranslateService,
		private messageService: MessageService) {
		this.sharedDataService.currentDepos.subscribe(depos => {
			this.loggedUserDepos = depos.map(d => d.toLowerCase());
		})
	}

	@ViewChild('ngChatInstance')
	protected ngChatInstance: IChatController;

	@Input()
	userId = 0;

	@Input() hide: boolean = false;



	openChats = {}; // key: id, value: chat

	ngOnInit() {
		this.chatService.getChatWithNewMessages().subscribe(data => {
			//this.openNewMessages(data);
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.message'));
		});
		this.messageSubcription = this.sharedDataService.currentNotification.subscribe(data => {
			this.parseNotification(data);
		});

		this.sharedDataService.currentUserUuid.subscribe(data => {


		});


	}


	parseNotification(n: Notification) {
		this.logger.log('parse notification', n);
		if (n && n.context === NotificatioContext.CHAT) {
			if (this.loggedUserDepos.indexOf(n.depocode.toLowerCase()) >= 0) {
				const chat = n.objectId;
				if (chat && chat !== '') {
					if (this.openChats[chat]) {
						this.showReceivedMessage(this.openChats[chat], n.data, n.id, n.cr === 1, n.ts);
					} else {
						this.chatService.getChatUser(chat).subscribe(data => {
							this.openChat(data);
							this.openChats[chat] = data;
						}, ({ error }) => {
							this.messageService.sendError(error, this.translateService.instant('labels.notifications'));
						});
					}
				}
			}
		} else if (n && n.context === NotificatioContext.STARTDISPATCH) {
			const chat = n.objectId;
			if (chat && chat !== '') {
				this.sharedDataService.sendAction('refreshchats', { chat });
			}
		}
	}



	showReceivedMessage(chat: Chat, message: string, id: number, controlroom: boolean, msgtimestamp: number) {

		if ((!chat.lastmsg || id !== chat.lastmsg.id) && chat.open) {
			if (controlroom) {
				const chatMessage = new ChatMessage(undefined, undefined, id, message, this.userId, id, false, msgtimestamp);
				this.adapter.messageReceivedHandler(chat, chatMessage);
			} else {
				const chatMessage = new ChatMessage(undefined, undefined, id, message, id, this.userId, true, msgtimestamp);
				this.adapter.onMessageReceived(chat, chatMessage);
			}
		}
		this.openChat(chat);

	}

	openNewMessages(chats: Chat[]) {
		this.logger.log('openNewMessages');
		if (chats) {
			for (let index = 0; index < chats.length; index++) {
				const element = chats[index];
				this.openChats[element.id] = element;
				if (element.lastmsg && !element.lastmsg.seen && element.lastmsg.fromuser !== this.userId) {
					this.openChat(element);
				}

			}
		}
	}

	ngOnDestroy(): void {
		if (this.messageSubcription) {
			this.messageSubcription.unsubscribe();
		}
	}


	openChat(user: Chat) {
		this.ngChatInstance.triggerOpenChatWindow(user);
	}

	chatOpened(event: any) {
		this.logger.log('chatOpened', event);
		this.openChats[event.id] = event;
		this.openChats[event.id].open = true;

		this.sharedDataService.sendAction('refreshchats');
	}

	chatClosed(event: any) {
		this.logger.log('chatClosed', event);
		if (this.openChats[event.id]) {
			this.openChats[event.id].open = false;
		}

	}

}
